import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ISubscriptionsResult } from '../models/register.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class RegisterService {
  constructor(private http: HttpClient) {}

  getPlanByTeamCode(teamCode: string): Observable<ISubscriptionsResult> {
    return this.http.get<ISubscriptionsResult>(
      environment.apiUrl + '/v1/subscription/list',
      {
        params: {
          team_code: teamCode,
        },
      }
    );
  }
}
